/**
 * Is SSN validation
 *
 * @param {*} value
 *
 * @return {String}
 */
export default function isSSN (value) {
    const pattern = /^\d{9}$/;

    return pattern.test(value) ? '' : 'validation.error.ssn';
}
